/* eslint-disable @typescript-eslint/no-unused-vars */
import type { FC } from "react";
import { Typography } from "@/design-system/Atoms";
import ListLinks from "@/design-system/Molecules/ListLinks";

const offeringsLinks: {
  listText: string;
  hrefText: string;
}[] = [];

interface AboutUsWhatWeOfferSectionProps {
  highlight?: string;
  heading?: string;
  variant?: "standard" | "highlighted";
  highlightedHeadingMain?: string;
  highlightedHeadingAccent?: string;
  sectionDescription?: string;
  listLinks: typeof offeringsLinks;
}
const AboutUsWhatWeOfferSection: FC<AboutUsWhatWeOfferSectionProps> = ({
  highlight,
  heading,
  variant,
  highlightedHeadingMain,
  highlightedHeadingAccent,
  sectionDescription,
  listLinks,
}) => {
  return (
    <section className="relative block w-full h-full pt-[75px] lg:pt-[160px] overflow-hidden">
      <div className="container px-4 mx-auto">
        <div className="flex flex-col lg:flex-row">
          <div className="lg:w-5/12">
            {highlight && (
              <Typography variant="categoryText" as="div" className="mb-10">
                {highlight}
              </Typography>
            )}

            {variant === "highlighted" &&
              highlightedHeadingMain &&
              highlightedHeadingAccent ? (
              <Typography variant="sectionHeading" as="h2" className="mb-10">
                <>
                  {highlightedHeadingMain}{" "}
                  <span className="text-gray-400">
                    {highlightedHeadingAccent}
                  </span>
                </>
              </Typography>
            ) : heading ? (
              <Typography variant="sectionHeading" as="h2" className="mb-10">
                {heading}
              </Typography>
            ) : null}

            {sectionDescription && (
              <Typography
                variant="sectionDescriptionLarge"
                as="p"
                className="mb-10"
              >
                {sectionDescription}
              </Typography>
            )}
          </div>
        </div>
        <div className="flex flex-col lg:flex-row">
          <div className="lg:block lg:w-15/12">
            {/*offeringsLinks is an array of objects with listText and hrefText properties*/}
            <ListLinks links={listLinks} />
          </div>
        </div>
      </div>
    </section>
  );
};
export default AboutUsWhatWeOfferSection;
